import baseService from "@/services/base.service";
import axios from 'axios';

class AuthService {
    constructor() {
    }

    /**
     * Login users with given details
     */
    loginUser = (email, password) => {
        return new Promise((resolve, reject) => {
            baseService.request(axios.post('login', {
                email: email,
                password: password
            })).then((user) => {
                resolve(user);
            }, (error) => {
                reject(this._handleError(error));
            });
        });
    }

    logout = () => {
        sessionStorage.setItem("authUser", null);
    }

    setLoggedInUser = (user) => {
        sessionStorage.setItem("authUser", JSON.stringify(user));
    }

    /**
     * Returns the authenticated users
     */
    getAuthenticatedUser = () => {
        if (!sessionStorage.getItem('authUser'))
            return null;
        return JSON.parse(sessionStorage.getItem('authUser'));
    }

    /**
     * Handle the error
     * @param {*} error
     */
    _handleError(error) {
        var errorMessage = error;
        return errorMessage;
    }
}

let _authService = null;

/**
 * Initilize the backend
 * @param {*} config
 */
const initAuthService = () => {
    if (!_authService) {
        _authService = new AuthService();
    }
    return _authService;
}

/**
 * Returns the firebase backend
 */
const getAuthService = () => {
    return _authService;
}

export {initAuthService, getAuthService};